import source from '@docs/expert-introduction.md?raw'
import scienceSource from '@docs/science-expert-introduction.md?raw'

/** Shared text for the guided tour and the permanent guide. */
const cards = (source: string) => source.split(/^### /m).slice(1).map(section => {
  const newline = section.indexOf('\n')
  return { title: section.slice(0, newline), body: section.slice(newline).trim() }
})
export const introductionCards = cards(source)
export const scienceIntroductionCards = cards(scienceSource)
export const introductionFor = (science: boolean) => science ? scienceIntroductionCards : introductionCards
export const INTRODUCTION_VERSION = 2
